/* eslint-disable @typescript-eslint/no-var-requires */
import {ComponentProps, ComponentType, createElement} from 'react';
import {ConfigurationApplication} from '@application/Config';
import {getAuth} from '@infra/api/authManager/authManager';
import {proxy} from '@infra/api/fetch/proxy';
import {Environment} from '@domain/model/Config/Configuration';
import {KameleoonEnvironment, bootstrap, SentryEnvironment} from '@lookiero/checkout';
import {version} from '@lookiero/checkout/package.json';
import {PROJECT_ID} from './sentryConfig';

const configuration = ConfigurationApplication.retrieve();

const sentryConfig = (): SentryEnvironment => ({
  publicKey: '66cadf9444db4ea5945670f12ec08ae7',
  release: `checkout@${version}`,
  project: PROJECT_ID,
  environment: configuration.environment === Environment.DEVELOPMENT ? 'development' : 'production',
});

const KAMELEOON_DEV = {
  siteCode: 'aplm4v3ckn',
  experiments: {
    newFeedback: {
      id: '245000',
      variations: {
        v1: '964072',
      },
    },
  },
};

const KAMELEOON_PROD = {
  siteCode: '0zj7mtr4bm',
  experiments: {
    newFeedback: {
      id: '247657',
      variations: {
        v1: '970269',
      },
    },
  },
};

const kameleoon = (): KameleoonEnvironment =>
  ConfigurationApplication.retrieve().environment === Environment.DEVELOPMENT ? KAMELEOON_DEV : KAMELEOON_PROD;

const checkoutBootstrap = (): ReturnType<typeof bootstrap> =>
  bootstrap({
    apiUrl: () => proxy('/checkout/api'),
    getAuthToken: getAuth as unknown as () => Promise<string>,
    sentry: sentryConfig,
    kameleoon,
  });

const defaultBootstrap = checkoutBootstrap();

const {firstAvailableCheckoutByCustomerId, root: checkoutRoot} = defaultBootstrap;

type CheckoutRootComponent = ReturnType<typeof checkoutRoot>;
type CheckoutRootProps = ComponentProps<CheckoutRootComponent>;

const root = ({customerId}: {customerId: string}): ComponentType<CheckoutRootProps> => {
  const RootComponent = checkoutRoot({customerId});

  const CheckoutRoot: ComponentType<CheckoutRootProps> = props => createElement(RootComponent, props);

  return CheckoutRoot;
};

export {firstAvailableCheckoutByCustomerId, root};
